<template>
  <div
    class="my-auto w-100 main-area"
    style="padding-top: 25px; margin-top: 15px !important; box-shadow:none;border: 0.5px solid #E6E6E6;border-radius:0px;background:white"
  >
    <div class="site-title-custom">
      <a style="color:#DD3847;cursor:pointer" @click="acceptUnsubscribe"
        >退会はこちら</a
      >
    </div>
  </div>
</template>

<script>
import Api from '@/config/api';
// eslint-disable-next-line
import swal from "sweetalert";
import logo from '../assets/Group300.png';

export default {
  methods: {
    async acceptUnsubscribe() {
      swal({
        title: '	本当に退会しますか？',
        text: '退会すると企業へのキャリア登録は解除され、当社からの連絡も今後入ることはありません。\n また、マイページへのログインはできなくなり、サービス利用には再度の登録が必要になります。',
        icon: 'warning',
        className: 'custom-swal',
        buttons: {
          cancel: 'キャンセル',
          ok: {
            text: '退会する',
            value: true,
            visible: true,
            closeModal: false,
            className: 'custom-red',
          },
        },
      }).then(async (ok) => {
        if (ok) {
          try {
            const token = await this.$auth.getToken();
            const response = await this.axios({
              method: 'delete',
              url: Api.url(Api.endpoints.deleteProfile),
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            const content = document.createElement('div');
            content.innerHTML = `
              <p class="swal-text m-0 w-75 text-center" style="font-weight:600">これまでのご利用、ありがとうございました。</p>
              <p class="swal-text m-0 w-75 text-center" style="font-weight:600">よろしければアンケートの回答にご協力をお願いします。</p>

              `;
            const res = await swal({
              title: '退会手続きが完了しました。',
              content,
              icon: logo,
              className: 'custom-swal3',
              closeOnClickOutside: true,
              closeOnEsc: false,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: 'swal-button swal-button--confirm',
                  closeModal: true,
                },
              },
            });
            if (res) {
              window.open('https://forms.gle/qdHsexvPJesPgwLT9');
              swal.close();
              this.$router.push({ name: 'Logout' });
            } else {
              swal.close();
              this.$router.push({ name: 'Logout' });
            }
          } catch (error) {
            console.log(error);
            if (error.response.status == 503) {
              this.$router.push({ name: 'Logout' });
            }

            // this.$router.push({ name: "Logout" });
          }
        }
      });
      // if (
      //   confirm("「Bloomキャリア登録」にご登録済みの情報を全て削除しますか？")
      // ) {

      // }
    },
  },
};
</script>

<style scoped></style>
